import {
    useMemo,
} from 'react'
import {
    Navigate,
} from 'react-router-dom'

import AQuotes from 'app/Apps/AccountManagement/AQuotes/AQuotes'
import {
    SkyNetRouteConfigObject, useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    PricingDomains,
} from 'app/enums/domain.enums'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import ContractBasis from './ContractBasis'
import Lanes from './Lanes'
import LaneGroups from './LaneGroups'
import LaneFees from './LaneFees'
import AlLogisticPricing from './AlLogisticPricing'
import AlLeasePricing from './AlLeasePricing'
import Dashboard from './Dashboard'

export default function Pricing() {
    const Routes = usePricingRoutes()
    const routesConfig: SkyNetRouteConfigObject<PricingDomains> = useMemo(() => {
        return {
            [Routes.PricingDashboard.route]: <Dashboard />,
            [Routes.ContractBasis.route]: <ContractBasis />,
            [Routes.LaneGroups.route]: <LaneGroups />,
            [Routes.LaneFees.route]: <LaneFees />,
            [Routes.Lanes.route]: <Lanes />,
            [Routes.AlLogisticPricing.route]: <AlLogisticPricing />,
            [Routes.AlLeasePricing.route]: <AlLeasePricing />,
            [Routes.AQuotes.route]: <AQuotes isCreateFormEnabled={false} />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.ContractBasis.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}
